import { useRef, useEffect, useState, useCallback } from 'react'

const importHammerJs = () => import('hammerjs')

type UseSwipeProps = {
  elementRef: React.RefObject<HTMLElement>
  leftSwipe: () => void
  rightSwipe: () => void
}

export const useSwipe = ({
  elementRef,
  leftSwipe,
  rightSwipe,
}: UseSwipeProps) => {
  const leftSwipeRef = useRef(() => {})
  leftSwipeRef.current = leftSwipe

  const rightSwipeRef = useRef(() => {})
  rightSwipeRef.current = rightSwipe

  const hammerRef = useRef<HammerStatic | null>(null)

  const [hammerLoaded, setHammerLoaded] = useState(false)

  const initHammer = useCallback(async () => {
    const importOfHammer = await importHammerJs()
    setHammerLoaded(true)
    hammerRef.current = importOfHammer.default
  }, [])

  useEffect(() => {
    if (hammerLoaded) {
      const Hammer: HammerStatic | null = hammerRef.current
      if (!Hammer) return () => {}

      const HammerScroll = new Hammer.Manager(elementRef.current as HTMLElement)
      const Swipe = new Hammer.Swipe()

      HammerScroll.add(Swipe)
      HammerScroll.on('swipeleft', () => {
        leftSwipeRef.current()
      })
      HammerScroll.on('swiperight', () => {
        rightSwipeRef.current()
      })

      return () => {
        HammerScroll.off('swipeleft')
        HammerScroll.off('swiperight')

        HammerScroll.remove(Swipe)
        HammerScroll.destroy()
      }
    }

    initHammer()

    return () => {}
  }, [
    elementRef,
    leftSwipeRef,
    rightSwipeRef,
    hammerRef,
    hammerLoaded,
    initHammer,
  ])
}
